// extracted by mini-css-extract-plugin
export var progressBar = "_lg-0";
export var progressBarInner = "_lg-1";